import React from "react";
import { Box } from "@mui/material";
import { WhatsappRedirection } from "../api/Redirection";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppFloatingIcon = () => {
  const handleClick = () => {
    window.open(WhatsappRedirection, "_blank"); 
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: "105px", sm: "30px" },
        height: { xs: "30px", sm: "60px" },
        width: { xs: "30px", sm: "60px" },
        right: { xs: "0", sm: "80px" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#F7EEE6",
        // background: "red",
        transition: "background-color 0.3s ease",
        cursor: "pointer",
        // borderRadius:{xs:"0",sm:"50%"},
        borderTopRightRadius: { xs: "0", sm: "50%" }, // Right top
        borderBottomRightRadius: { xs: "0", sm: "50%" }, // Right bottom
        borderTopLeftRadius: { xs: "50%", sm: "50%" }, // Left top
        borderBottomLeftRadius: { xs: "50%", sm: "50%" }, // Left bottom
        padding: { xs: "7px", sm: "5px" },
        zIndex: 3,
        "&:hover": {
          backgroundColor: "#F7EEE6",
        },
      }}
      onClick={handleClick}
    >
      <WhatsAppIcon
        sx={{ fontSize: { xs: "30px", sm: "50px" }, color: "#B8772A" }}
      />
    </Box>
  );
};

export default WhatsAppFloatingIcon;
